import React from "react";
import {FooterSection} from "../components/Footer.jsx";
import {Link} from "react-router-dom";
import {Menu, X} from "lucide-react";

const PrivacyPageApp = () => {
    return (
        <div className="min-h-screen bg-zinc-900 text-gray-100">
            {/* NavBar */}
            <nav className="sticky top-0 z-50 bg-[#1a1a1a] border-b border-[#FF4D00]/10 backdrop-blur-sm">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex items-center justify-between h-16">
                        {/* Logo */}
                        <Link to="/" className="flex items-center space-x-3">
                            <div className="w-8 h-8">
                                <img
                                    src={require("../assets/helga_launcher_icon.png")}
                                    alt="Helga Logo"
                                    className="w-full h-full object-contain"
                                />
                            </div>
                            <span
                                className="text-2xl font-bold bg-clip-text text-[#FF4D00]">
                                Helga Festival Companion
                             </span>
                        </Link>
                    </div>
                </div>
            </nav>


            {/* Main Content */}
            <main className="py-12">
                <div className="max-w-4xl mx-auto px-4">
                    <div className="prose prose-invert max-w-none">
                        <div className="bg-white/5 p-8 rounded-2xl backdrop-blur-sm border border-[#FF4D00]/10">
                            <h2 className="text-2xl font-semibold mb-6 text-[#FF4D00]">Privacy</h2>

                            <h3 className="text-xl font-semibold mt-8 mb-4">Privacy Policy</h3>
                            <p className="text-gray-300 mb-4">This privacy policy applies to the mobile Helga app
                                (hereinafter referred to as "App" or "Helga app").</p>

                            <h3 className="text-xl font-semibold mt-8 mb-4">1. General</h3>
                            <p className="text-gray-300 mb-4">Regarding the services, apirious GmbH, Bad Nauheimer
                                Straße 4, 64289 Darmstadt ("apirious", "we", "us" or "our") is the data controller
                                within the meaning of the General Data Protection Regulation ("GDPR"). This privacy
                                policy informs you about how we collect, process and use personal data in connection
                                with our services.</p>


                            <h3 className="text-xl font-semibold mt-8 mb-4">2. Data we collect, process and use</h3>
                            <ul className="list-disc text-gray-300 mb-4">
                                <li>
                                    In case you contact us via email, we will store your email address to be able to
                                    respond to your inquiry. We delete the data generated in this context as soon as
                                    storage is no longer necessary. If further storage of the data is required by legal
                                    regulations, we will restrict the processing of this data.
                                </li>
                                <li>
                                    The app is available for the iOS and Android operating systems. When downloading the
                                    app from the respective store (App Store (iOS) or Play Store (Android)), the
                                    necessary information is transmitted to the operator of the respective store. This
                                    data includes email address, username, time of visit, time of download, payment
                                    information, and the customer number of your user account. We only use this data to
                                    the extent necessary to download the app to your mobile device. We do not store this
                                    data beyond that. We have no influence on the collection of the mentioned data by
                                    the store operators and do not assume any responsibility.
                                </li>
                                <li>
                                    Should we use services from service providers commissioned by us for certain
                                    functions of the Helga app or want to use your data for advertising purposes, we
                                    will inform you in detail about the respective processes.
                                </li>
                                <li>
                                    For the use of the Helga app, we collect the following personal data to ensure the
                                    usability of our services:
                                    <ol type="a">
                                        <li>Firebase ID: the ID generated when starting the app to authenticate the user
                                            via Firebase.
                                        </li>
                                    </ol>
                                </li>
                                <li>We generally do not use the above-mentioned data for the purpose of personal
                                    analysis of user behavior or profiling.
                                </li>
                                <li>In addition, the app collects certain data transmitted by your mobile device. This
                                    includes your IP address, the registration date of your user account, periods in
                                    which you use the app, the operating system of your device (Android or iOS), and the
                                    device type (e.g., Samsung Galaxy or iPhone). These data are collected in particular
                                    for the purpose of distinguishing actual app users from bots and preventing abusive
                                    use. Additionally, this data helps us to fix errors in the app.
                                </li>
                            </ul>

                            <h3 className="text-xl font-semibold mt-8 mb-4">3. Voluntary provision of data to improve
                                the app</h3>
                            <p className="text-gray-300 mb-4">he following data is only collected if the user has
                                explicitly consented to the collection. This data is collected exclusively for the
                                purpose of fixing errors in the app and analyzing which functions are used particularly
                                frequently in order to plan the further development of the app meaningfully from the
                                user's perspective.</p>
                            <ul className="list-disc text-gray-300 mb-4">
                                <li>
                                    Crash logs: With the user's consent, so-called crash logs can be transmitted to
                                    apirious. These crash logs occur when an error occurs in the app that does not
                                    correspond to the expected behavior, such as when certain information about a
                                    festival cannot be loaded. The crash logs show the software developers which lines
                                    of code in the software were last executed before the error occurred. This allows
                                    the cause of the error to be quickly identified and the error to be fixed.
                                </li>
                                <li>
                                    Usage data: With the user's consent, anonymous usage data can be collected, which
                                    apirious uses to recognize how and how often certain functions of the app are used.
                                    This helps us better understand which functions are particularly important to users
                                    and thus focus on the further development of the app.
                                </li>
                            </ul>
                            <p className="text-gray-300 mb-4">For the purpose of crash analysis and error reporting, our
                                mobile application utilizes
                                Crashlytics, a crash reporting service provided by Google LLC. Crashlytics collects and
                                sends crash logs and error information to Google servers for analysis. These crash logs
                                may contain information such as device information, operating system version, and
                                application state at the time of the crash. By using Crashlytics, we aim to improve the
                                stability and performance of our mobile application. Please note that the collection and
                                processing of crash logs by Crashlytics are subject to Google's privacy policy.</p>

                            <h3 className="text-xl font-semibold mt-8 mb-4">4. Storage of data</h3>
                            <p className="text-gray-300 mb-4">The data collected is transmitted and encrypted on the
                                systems of Amazon Web Services
                                (Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, L-1855 Luxembourg,
                                hereinafter "AWS"), in the "Frankfurt / Germany" availability zone. AWS guarantees not
                                to transfer the data outside the availability zone <a
                                    href="http://aws.amazon.com/de/agreement/">§3.2</a>). The rights to the stored data
                                lie with the client and not with Amazon in accordance with <a
                                    href="http://aws.amazon.com/de/agreement/">§8.1</a>. Amazon has been contractually
                                obliged by us to comply with data protection regulations. Further information can be
                                found in the <a href="https://aws.amazon.com/de/privacy/">AWS privacy policy</a>.</p>

                            <h3 className="text-xl font-semibold mt-8 mb-4">5. Recipients of personal data</h3>
                            <p className="text-gray-300 mb-4">We only disclose personal information if required by law,
                                if you have consented, or if we
                                are authorized to do so. If these conditions are met, recipients of personal data may
                                include:</p>
                            <ul className="list-disc text-gray-300 mb-4">
                                <li>Public authorities (e.g., law enforcement authorities) if there is a legal or
                                    regulatory obligation.
                                </li>

                                <li>For certain functions, we use services from service providers who process personal
                                    data on our behalf to provide the technical platform for our services. These service
                                    providers process the data exclusively according to our instructions (data
                                    processing). The legal basis for data processing described in this section 4 is GDPR
                                    Article 6 (1) (b) (lawfulness of processing) and GDPR 28 (processor).
                                </li>
                            </ul>

                            <h3 className="text-xl font-semibold mt-8 mb-4">6. Legal basis for processing personal
                                data</h3>
                            <p className="text-gray-300 mb-4">We process your personal data in compliance with the
                                applicable data protection
                                regulations. The processing is lawful if the following conditions are met: - Consent
                                (Article 6 (1) (a) GDPR: The processing of personal data is lawful if consent to
                                processing for specified purposes (e.g., processing your request, using the data for
                                marketing purposes) is given. Any consent given can be revoked at any time with effect
                                for the future. This also applies to the revocation of consents given before the GDPR,
                                i.e., before May 25, 2018.</p>

                            <ul className="list-disc text-gray-300 mb-4">
                                <li>For the performance of a contract (Art. 6 (1) (b) GDPR) Where we process personal
                                    data necessary to provide you with the functions of the app, this is done to fulfill
                                    the contract with you in accordance with Art. 6 (1) (b) GDPR
                                </li>

                                <li>As part of the balancing of interests (Article 6 (1) (f) GDPR): If necessary, we
                                    process your data beyond the actual fulfillment of the contract to safeguard
                                    legitimate interests of us or third parties. Examples:
                                </li>
                                <ol type="a" className="list-decimal text-gray-300 mb-4">
                                    <li>Asserting legal claims and defending against legal disputes</li>
                                    <li>Ensuring IT security and IT operations</li>
                                </ol>
                            </ul>

                            <h3 className="text-xl font-semibold mt-8 mb-4">7. Intention to transfer personal data to a
                                third country or an international organization</h3>
                            <p className="text-gray-300 mb-4">An active transfer of personal data to a third country
                                only takes place if it has been
                                expressly indicated in the context of the aforementioned services.</p>

                            <h3 className="text-xl font-semibold mt-8 mb-4">8. Duration of storage of personal data</h3>
                            <p className="text-gray-300 mb-4">Unless a shorter storage period is specified in this
                                privacy policy, we generally store
                                personal data for as long as (i) necessary for the provision of the services to you
                                and/or (ii) required with regard to the contractual relationship with you; thereafter,
                                the data will only be stored to the extent required by legal retention obligations. If
                                we no longer need the relevant personal data for the purposes described above, this
                                personal data will only be stored for the duration of the respective legal retention
                                obligations and will not be processed for other purposes.</p>

                            <h3 className="text-xl font-semibold mt-8 mb-4">9. Data protection rights</h3>
                            <ul className="list-disc text-gray-300 mb-4">
                                <li>Every data subject has the right to information pursuant to Article 15 GDPR, the
                                    right to rectification pursuant to Article 16 GDPR, the right to erasure pursuant to
                                    Article 17 GDPR, the right to restriction of processing pursuant to Article 18 GDPR,
                                    the right to object pursuant to Article 21 GDPR, and the right to data portability
                                    pursuant to Article 20 GDPR. The restrictions pursuant to §§ 34 and 35 BDSG apply to
                                    the right to information and the right to erasure. In addition, there is a right to
                                    lodge a complaint with a competent data protection supervisory authority (Article 77
                                    GDPR in conjunction with § 19 BDSG).
                                </li>

                                <li>You can revoke your consent to the processing of personal data at any time with
                                    effect for the future. This also applies to the revocation of declarations of
                                    consent that were given to us before the GDPR came into effect, i.e., before May 25,
                                    2018.
                                </li>

                                <li>The revocation of consent and objection pursuant to Article 21 GDPR can be made
                                    informally and should be addressed to:
                                </li>
                            </ul>
                            <p className="text-gray-300 mb-4">apirious GmbH<br/>
                                The Data Protection Officer<br/>
                                Bad Nauheimer Straße 4,<br/>
                                64289 Darmstadt<br/>
                                Email: contact@apirious.de</p>

                            <h3 className="text-xl font-semibold mt-8 mb-4">10. Collection of statistical
                                indicators</h3>
                            <p className="text-gray-300 mb-4">We collect the number of active users of this app on iOS
                                devices using the
                                IdentifierForVendor (IDFV) function. The IDFV is a unique but non-personalized and
                                non-permanent number stored on your mobile device. The data collected via the IDFV is
                                not linked to any other device-related information.</p>
                            <p className="text-gray-300 mb-4">We collect the number of active users of this app on
                                Android devices using the
                                device-specific ID.</p>
                            <p className="text-gray-300 mb-4">Data processing for the purpose of determining active
                                users is anonymized.</p>

                            <h3 className="text-xl font-semibold mt-8 mb-4">11. Automatic creation of backups</h3>
                            <p className="text-gray-300 mb-4">Backups of the data from ongoing operations are created daily. The backups of your data
                                are stored encrypted. These backups are located at AWS and are automatically deleted
                                after two weeks. The backups are created to restore a functioning state in the event of
                                serious errors in the running system and thus guarantee the most fail-safe operation of
                                the Helga app.</p>

                        </div>
                    </div>
                </div>
            </main>
            <>
                <FooterSection/>
            </>
        </div>
    );
};

export default PrivacyPageApp;